import bold from "./Ubuntu-Bold.ttf";
import boldItalic from "./Ubuntu-BoldItalic.ttf";
import italic from "./Ubuntu-Italic.ttf";
import light from "./Ubuntu-Light.ttf";
import lightItalic from "./Ubuntu-LightItalic.ttf";
import medium from "./Ubuntu-Medium.ttf";
import mediumItalic from "./Ubuntu-MediumItalic.ttf";
import regular from "./Ubuntu-Regular.ttf";
import { createGlobalStyle } from "styled-components";

interface Definition {
  src: string;
  weight?: number;
  italic?: true;
}

const definitions: Definition[] = [
  {
    src: bold,
    weight: 700,
  },
  {
    src: boldItalic,
    weight: 700,
    italic: true,
  },
  {
    src: italic,
    italic: true,
  },
  {
    src: light,
    weight: 300,
  },
  {
    src: lightItalic,
    weight: 300,
    italic: true,
  },
  {
    src: medium,
    weight: 500,
  },
  {
    src: mediumItalic,
    weight: 500,
    italic: true,
  },
  {
    src: regular,
  },
];

export const UbuntuFontFace = createGlobalStyle`
  ${definitions
    .map(
      ({ src, weight, italic }) => `
    @font-face {
      font-family: 'Ubuntu';
      src: url('${src}');
      ${weight ? `font-weight: ${weight};` : ""}
      ${italic ? `font-style: italic;` : ""}
    }
  `
    )
    .join("")}
`;
